import { _apipe, _when } from '..';

import type { ExperimentConfig } from './constants';
import { CONTROL_FEATURE_VALUE,DEFAULT_FEATURE_VALUE } from './constants';
import { _getFeatureValue, _initGrowthbook } from './index';

const currentPathname = window.location.pathname;

function runSplitUrlExperiment({ featureId, alternativeUrls }) {
  const timeoutId = setTimeout(() => {
    removeAntiFlicker();
  }, 5000);

  const runExpriment = ({ featureValue }) => {
    /**
     * Є домовленість, що CONTROL_FEATURE_VALUE (основна сторінка) це завжди 1.
     * Отже альтернативні сторінки починається з 2.
     */
    const alternativeUrl = alternativeUrls[featureValue - 2];

    if (alternativeUrl === currentPathname) {
      removeAntiFlicker();
      clearTimeout(timeoutId);
    } else {
      window.location.assign(alternativeUrl);
    }
  };

  return _apipe(
    _initGrowthbook,
    _getFeatureValue(featureId, DEFAULT_FEATURE_VALUE),
    /**
     * Зайшов на сторінку на якій запускається експеримент і випала вона
     * Або не цільова сторінка (будь-яка інша)
     * Прибираємо antiflicker
     */
    _when(
      ({ featureValue }) =>
        featureValue === DEFAULT_FEATURE_VALUE || featureValue === CONTROL_FEATURE_VALUE,
      removeAntiFlicker,
    ),
    // Сторінка на якій запускається експеримент (alternativeUrls)
    _when(
      ({ featureValue }) =>
        featureValue !== DEFAULT_FEATURE_VALUE && featureValue !== CONTROL_FEATURE_VALUE,
      runExpriment,
    ),
  )();
}

if (window.SplitUrlExperiments && window.SplitUrlExperiments.length) {
  window.SplitUrlExperiments.forEach(experiment => {
    if (
      experiment.targetPathname === currentPathname ||
      // Щоб запустився експеримент на альтернативних сторінках і пушнувся івент
      experiment.alternativeUrls.includes(currentPathname)
    ) {
      runSplitUrlExperiment(experiment);
    }
  });
}

function removeAntiFlicker(state?: ExperimentConfig) {
  const antiFlickerStyle = document.getElementById('antiFlicker');

  if (antiFlickerStyle && antiFlickerStyle.parentNode) {
    antiFlickerStyle.parentNode.removeChild(antiFlickerStyle);
  }

  return state;
}
